import { render, staticRenderFns } from "./MeuTime.vue?vue&type=template&id=387b327f&scoped=true"
import script from "./MeuTime.vue?vue&type=script&lang=js"
export * from "./MeuTime.vue?vue&type=script&lang=js"
import style0 from "./MeuTime.vue?vue&type=style&index=0&id=387b327f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b327f",
  null
  
)

export default component.exports